export default __webpack_public_path__ + "static/media/GooglePlay.6c132c70.png";